<template>
  <div id="content">
    <v-card class="justify-center">
      <v-card-title>
        Vrije teksten
        <v-spacer></v-spacer>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="generalMessages"
        hide-default-footer
        :items-per-page="1000"
      >
        <template v-slot:item.actions="{ item }">
          <v-icon
            small
            v-on:click.stop="deleteGeneralMessage(item)"
          >mdi-delete</v-icon>
        </template>
      </v-data-table>
    </v-card>
    <v-btn color="secondary" fixed bottom right fab @click="newGeneralMessage">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Nieuwe vrije tekst</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="general_message_creation" v-model="valid">
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="8">
                  <v-textarea
                    label="Tekst"
                    :rules="[v => !!v || 'Invoer van een tekst is verplicht.']"
                    v-model="msgcontent"
                    auto-grow
                    rows="1"
                    required
                    counter="255"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <span class="subtitle-2">Starttijd:</span>
                  <datetime v-model="startdatetime" :minute-step="5" type="datetime" title="Start"></datetime>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <span class="subtitle-2">Eindtijd:</span>
                  <datetime v-model="enddatetime" :minute-step="5" type="datetime" title="Einde"></datetime>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="8">
                  <v-select
                    v-model="selectedQuays"
                    :items="availableQuays"
                    :menu-props="{ maxHeight: '400' }"
                    label="Actief op perrons"
                    multiple
                    hint="Kies de perrons waarop dit bericht getoond moet worden."
                    chips
                    persistent-hint
                    required
                    :rules="[v => v.length > 0 || 'Selecteer tenminste een perron.']"
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Annuleer</v-btn>
          <v-btn color="blue darken-1" text @click="saveGeneralMessage">Opslaan</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      headers: [
        {
          text: "Datum van aanmaken",
          align: "start",
          value: "messagecodedate"
        },
        { text: "Tekst", value: "msgcontent" },
        { text: "Starttijd", value: "msgstarttime" },
        { text: "Eindtijd", value: "msgendtime" },
        { text: "Weergave op perrons", value: "sidecodes" },
        { text: "", value: "actions", sortable: false }
      ],
      generalMessages: [],
      dialog: false,
      valid: false,
      msgcontent: "",
      startdatetime: moment().format(),
      enddatetime: moment()
        .add(2, "days")
        .format(),
      availableQuays: [
        {value: "NL:Q:54447710", text: "A"},
        {value: "NL:Q:54447610", text: "B"},
        {value: "NL:Q:54447510", text: "C"},
        {value: "NL:Q:54447410", text: "D"},
        {value: "NL:Q:54447310", text: "E"},
        {value: "NL:Q:54447210", text: "F"},
        {value: "NL:Q:54447110", text: "G"}
      ],
      selectedQuays: []
    };
  },
  mounted() {
    this.loadGeneralMessages();
  },
  methods: {
    loadGeneralMessages: function () {
      this.$http.get("/general_messages").then(response => {
        this.generalMessages = response.data;
      });
    },
    newGeneralMessage: function(event) {
      this.dialog = true;
    },
    saveGeneralMessage: function(event) {
      this.$refs.general_message_creation.validate();
      if (this.valid) {
        this.createGeneralMessage(event);
        this.dialog = false;
      }
    },
    createGeneralMessage: function(event) {
      this.$http
        .post(this.baseUrl + "/general_message", {
          msgcontent: this.msgcontent,
          msgstarttime: this.startdatetime,
          msgendtime: this.enddatetime,
          quays: this.selectedQuays
        })
        .then(response => {
          this.generalMessages.push(response.data);
          // this is uggly but it works...
          this.loadGeneralMessages();
        });
    },
    deleteGeneralMessage: function(event) {
      this.$http
        .delete(this.baseUrl + "/general_message/" + event.id)
        .then(response => {
          const index = this.generalMessages.indexOf(event);
          this.generalMessages.splice(index, 1);
        });
    }
  }
};
</script>

<style scoped>
#content {
  max-width: 1000px;
  align-content: center;
}
</style>
